import axios from "axios";
import {
  getClientByCuitEndpoint,
  newBillEndpoint,
  serviceStatusEndpoint,
  resendBillEndpoint,
  ivaBookEndpoint,
} from "./endpoints";
import { logApiCall, logError } from "../utils/logger";
import { sendErrorNotification } from "../utils/emailSender";

const authenticationObject = {
  usertoken: process.env.REACT_APP_TUSFACURAS_USERTOKEN,
  apitoken: process.env.REACT_APP_TUSFACTURAS_APITOKEN,
  apikey: process.env.REACT_APP_TUSFACTURAS_APIKEY,
};

// Función auxiliar para modificar el mensaje de error agregando "( tusfacturas.app )"
const formatTusfacturasError = (error) => {
  if (error && error.message) {
    // Solo agregar si no está ya presente para evitar duplicados
    if (!error.message.includes("(tusfacturas.app)")) {
      error.message = error.message + " (tusfacturas.app)";
    }
  } else if (error) {
    // Si el error no tiene message, crear uno
    error.message = "Error en llamada a tusfacturas.app (tusfacturas.app)";
  }
  return error;
};

export const createNewBill = async (bill, client, ticketId = null, orderIds = null) => {
  const data = JSON.stringify({
    ...authenticationObject,
    comprobante: bill,
    cliente: client,
  });
  
  try {
    const response = await axios.post(newBillEndpoint, data);
    
    // Log successful API call
    try {
      await logApiCall(
        ticketId,
        orderIds,
        response.data?.comprobante_nro || null,
        { comprobante: bill, cliente: client },
        response.data,
        null,
        "Llamada exitosa a tusfacturas.app"
      );
    } catch (logError) {
      // No fallar si el logging falla
    }
    
    return response.data;
  } catch (error) {
    // Formatear el mensaje de error
    const formattedError = formatTusfacturasError(error);
    
    // Log error
    try {
      await logError(
        formattedError,
        "createNewBill - tusfacturas.app",
        ticketId,
        orderIds,
        null
      );
    } catch (logError) {
      // Error logging handled silently
    }
    
    // Send error notification email
    try {
      await sendErrorNotification(formattedError, "createNewBill - tusfacturas.app");
    } catch (emailError) {
      // Email error handled silently
    }
    
    throw formattedError;
  }
};

export const getClientDataByCuit = async (client) => {
  const data = JSON.stringify({
    ...authenticationObject,
    cliente: client,
  });
  try {
    const response = await axios.post(getClientByCuitEndpoint, data);
    return response.data;
  } catch (error) {
    // Formatear el mensaje de error
    const formattedError = formatTusfacturasError(error);
    
    // Log error
    try {
      await logError(
        formattedError,
        "getClientDataByCuit - tusfacturas.app",
        null,
        null,
        null
      );
    } catch (logError) {
      // Error logging handled silently
    }
    
    // Send error notification email
    try {
      await sendErrorNotification(formattedError, "getClientDataByCuit - tusfacturas.app");
    } catch (emailError) {
      // Email error handled silently
    }
    
    throw formattedError;
  }
};

export const getServiceStatus = async () => {
  const data = JSON.stringify(authenticationObject);
  try {
    const response = await axios.post(serviceStatusEndpoint, data);
    return response.data;
  } catch (error) {
    // Formatear el mensaje de error
    const formattedError = formatTusfacturasError(error);
    throw formattedError;
  }
};

export const resendBill = async (ticketType, ticketNumber) => {
  // Extraer punto de venta y número del ticketNumber (formato: "00005-00001234")
  const [puntoVenta, numero] = ticketNumber.split('-');
  
  const data = JSON.stringify({
    ...authenticationObject,
    comprobante: {
      tipo: ticketType,
      operacion: "V",
      punto_venta: puntoVenta,
      numero: numero,
    },
  });

  try {
    const response = await axios.post(resendBillEndpoint, data);
    return response.data;
  } catch (error) {
    // Formatear el mensaje de error
    const formattedError = formatTusfacturasError(error);
    
    // Log error
    try {
      await logError(
        formattedError,
        "resendBill - tusfacturas.app",
        null,
        null,
        null
      );
    } catch (logErr) {
      // Error logging handled silently
    }
    
    throw formattedError;
  }
};


/**
 * Libro IVA compras y ventas de un período.
 *
 * OJO: este endpoint no devuelve el libro. Lo encola en tusfacturas.app y lo
 * envía por mail a la dirección indicada. La respuesta sólo dice si lo tomó.
 */
export const requestIvaBook = async ({ mes, anio, email }) => {
  const data = JSON.stringify({ ...authenticationObject, mes, anio, email });

  try {
    const response = await axios.post(ivaBookEndpoint, data);
    return response.data;
  } catch (error) {
    throw formatTusfacturasError(error);
  }
};
